interface AssigneeAvatarProps {
  name: string;
  size?: 'sm' | 'md';
}

const sizeClasses: Record<'sm' | 'md', string> = {
  sm: 'w-6 h-6 text-[10px]',
  md: 'w-8 h-8 text-xs',
};

function getInitials(name: string): string {
  const parts = name.trim().split(/\s+/);
  const first = parts[0]?.[0] ?? '';
  const last = parts.length > 1 ? (parts[parts.length - 1]![0] ?? '') : '';
  return (first + last).toUpperCase();
}

export function AssigneeAvatar({name, size = 'md'}: AssigneeAvatarProps) {
  return (
    <div
      title={name}
      className={`bg-blue-100 text-blue-700 rounded-full flex items-center justify-center font-medium ${sizeClasses[size]}`}
    >
      {getInitials(name)}
    </div>
  );
}
